var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("button", { staticClass: "btn btn-link", on: { click: _vm.open } }, [
        _c("i", { staticClass: "fas fa-cog" })
      ]),
      _vm._v(" "),
      _c("DutySettingsModal", {
        ref: "modal",
        on: {
          imported: function($event) {
            return _vm.$emit("imported")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }